import ExtendedImage from './ExtendedImage';

export default ExtendedImage;
